import { render, staticRenderFns } from "./BaseWebPage.vue?vue&type=template&id=402812ce&"
import script from "./BaseWebPage.vue?vue&type=script&lang=js&"
export * from "./BaseWebPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports